import styled from "styled-components";

const UILabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 8px;
  position: relative;
  text-align: left;

  &.nested {
    margin: 0;
  }
  &.nested .input {
    margin: 8px 0 0;
  }
`;

export default UILabel;
